import { forwardRef } from "react";
import { IconType } from "enums/Icon";
import { useTranslation } from "react-i18next";
import Icon from "../Icon/Icon";
import IconButton, { IconButtonProps } from "../IconButton";

type CloseButtonProps = Omit<IconButtonProps, "aria-label" | "children"> & {
  "aria-label"?: string;
};

// The one close control: drawers, dialogs, modals, the mobile menu and the
// filter bar all close with it.
const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  (props, ref) => {
    const { t } = useTranslation("common");

    return (
      <IconButton
        ref={ref}
        aria-label={t("common.close")}
        title={t("common.close")}
        {...props}
      >
        <Icon type={IconType.Close} />
      </IconButton>
    );
  },
);

CloseButton.displayName = "CloseButton";

export default CloseButton;
